"use client"

import * as React from "react"

/**
 * Cart context seam (US-011). The real cart (add/edit/remove line items, priced by
 * packages/ordering) lands in US-029 — this provider only exposes an empty,
 * immutable cart so the provider tree matches the retail shape and downstream code
 * can call `useCart()` today.
 */
export interface CartValue {
  /** Empty until US-029 wires the real cart. */
  items: readonly never[]
}

const CartContext = React.createContext<CartValue | null>(null)

export function CartProvider({ children }: { children: React.ReactNode }) {
  const value = React.useMemo<CartValue>(() => ({ items: [] }), [])
  return <CartContext.Provider value={value}>{children}</CartContext.Provider>
}

export function useCart(): CartValue {
  const ctx = React.useContext(CartContext)
  if (!ctx) {
    throw new Error("useCart must be used within a CartProvider")
  }
  return ctx
}
